<main id="dashboard">
  <ng-container *ngIf="!componentReady" class="loading-spinner-container min-vh-100 min-vw-100 position-relative">
    <div class=" position-absolute position-absolute top-50 start-50 translate-middle">
      <div class="spinner-border text-primary loading-spinner-lg" role="status">
        <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!isOperator && componentReady">
    <app-dashboard-profile></app-dashboard-profile>
    <app-dashboard-charging-points></app-dashboard-charging-points>
    <app-dashboard-running-transactions *ngIf="showRunningTransactions"
      [initialTransactions]="runningTransactions"></app-dashboard-running-transactions>
    <app-dashboard-power-chart></app-dashboard-power-chart>
    <app-dashboard-transactions></app-dashboard-transactions>
  </ng-container>
  <ng-container *ngIf="isOperator && componentReady">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-4 col-xl-3">
          <app-dashboard-profile></app-dashboard-profile>
        </div>
        <div class="col-12 col-md-12 col-lg-8 col-xl-9">
          <div class="row">
            <div class="col-12">
              <app-dashboard-charging-points></app-dashboard-charging-points>
            </div>
            <div class="col-12">
              <app-dashboard-running-transactions *ngIf="showRunningTransactions"
                [initialTransactions]="runningTransactions"></app-dashboard-running-transactions>
            </div>
            <div class="col-12">
              <app-dashboard-power-chart></app-dashboard-power-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-dashboard-transactions></app-dashboard-transactions>
  </ng-container>
</main>

<div class="modal simple" tabindex="-1" role="dialog" [class]="showAutoBillingNotification ? 'show' : ''">
  <div class="modal-content" role="document" style="max-width: 640px;">
    <div class="modal-header">
      <h5 class="modal-title">
        <span i18n="@@AutoBillingNotificationTitle">Automatische monatliche Abrechnung Ihrer Ladevorgänge</span>
      </h5>
      <button type="button" id="x_close" data-bs-dismiss="modal" aria-label="Close" class="btn-close"
        (click)="showAutoBillingNotification = false"></button>
    </div>

    <div class="modal-body" style="display: flex; gap: 2rem;">
      <div>
        <h4>Ihr Tarif in diesem Ladepark</h4>
        <p i18n="@@AutoBillingNotificationInfo">Um die Nutzung der Ladestationen zu erleichtern, verwendet dieser
          Ladepark die automatische monatliche Abrechnung.</p>
        <p i18n="@@AutoBillingNotificationCTA">Bitte geben Sie eine Zahlungsmethode an, damit wir die anfallenden Kosten
          für das Laden Ihres Elektrofahrzeugs jeden Monat automatisch von Ihrem Konto abbuchen können.</p>
      </div>
      <div style="background: #eee; margin: -1rem; padding: 1rem;" *ngIf="pricing">
        <h4>{{ pricing.name }}</h4>
        <h2><strong>{{ pricing.price | currency:'EUR' }}</strong></h2>
        <p>{{ pricing.description }}</p>
        <p><small>pro geladener kWh. Monatlich abgerechnet je nach Nutzung. Die Berechnung erfolgt in Wh. 1 kWh
            entspricht 1000 Wh.</small></p>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-yellow" (click)="showAutoBillingNotification = false"
        [routerLink]="['/profile/charging-park-subscription']" i18n="@@AutoBillingNotificationButton">Zahlungsmethode
        erstellen</button>
    </div>
  </div>
</div>

<router-outlet></router-outlet>